export default "* Ask & Liv-ark til farvejagt ELLER æggebakke til 6 æg med en farve i hvert hul\n* Dobbeltklæbende tape\n";